import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import '@/assets/css/main.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
import { createI18n } from 'vue-i18n'
import fa from './locales/fa.json'
import en from './locales/en.json'
import ar from './locales/ar.json'
import { initTheme } from "./utils/theme"

initTheme()
const savedLang = localStorage.getItem("lang") || "fa"

const i18n = createI18n({
  legacy: false,
  locale: savedLang,
  fallbackLocale: "fa",
  messages: {
    fa,
    en,
    ar
  }
})

const pinia = createPinia()
const app = createApp(App)

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
            .then((reg) => console.log('SW registered:', reg.scope))
            .catch((err) => console.error('SW registration failed:', err))
    })
}

// main.js (after app is mounted)
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    const msg = event.data
    if (msg?.type === 'NAVIGATE' && msg.url) {
      router.push(msg.url)
    }
  })
}

app.config.globalProperties.$apiBaseUrl = 'https://nifty-morse-jcyqjiggd.liara.run'
app.component('DatePicker', Vue3PersianDatetimePicker)

app.use(router)
app.use(pinia)
app.use(i18n)

app.mount('#app')